import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class RouterInitStatusService {
  private readonly _initialized = new BehaviorSubject<boolean>(false);

  public routerInititlized$ = this._initialized.asObservable();

  setInitializerStatus(value: boolean) {
    this._initialized.next(value);
  }
}
